export const messages = {
  en: {
    propertyCommunity: {
      page: {
        title: 'Property Community',
        subtitle: 'Communities the current company has joined, with entry status and available function groups',
        empty: 'No community records',
        loadFailed: 'Failed to load community list, please retry',
        tip: 'Only communities with an approved entry can be edited; quitting requires confirmation'
      },
      search: {
        title: 'Search Conditions',
        communityId: 'Please enter community ID',
        name: 'Please enter community name'
      },
      list: {
        title: 'Community Information',
        add: 'Join Community',
        quit: 'Quit Community'
      },
      table: {
        communityId: 'Community ID',
        name: 'Community Name',
        nearbyLandmarks: 'Nearby Landmarks',
        cityCode: 'City Code',
        state: 'Status'
      },
      add: {
        title: 'Add Community',
        openCommunity: 'Open Community',
        selectCommunity: 'Optional, please select community',
        functions: 'Functions',
        all: 'All'
      },
      edit: {
        title: 'Edit Community',
        openCommunity: 'Open Community',
        functions: 'Functions',
        all: 'All'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to quit this community?',
        cancel: 'Cancel',
        confirmButton: 'Confirm Quit'
      },
      fetchError: 'Failed to fetch community data'
    },

  },
  zh: {
    propertyCommunity: {
      page: {
        title: '物业小区',
        subtitle: '本公司已入驻的小区及其入驻状态与可用功能组',
        empty: '暂无小区记录',
        loadFailed: '小区列表加载失败，请重试',
        tip: '仅「入驻成功」的小区可修改；退出小区需二次确认'
      },
      search: {
        title: '查询条件',
        communityId: '请输入小区编号',
        name: '请输入小区名称'
      },
      list: {
        title: '小区信息',
        add: '加入小区',
        quit: '退出小区'
      },
      table: {
        communityId: '小区ID',
        name: '小区名称',
        nearbyLandmarks: '附近地标',
        cityCode: '城市编码',
        state: '状态'
      },
      add: {
        title: '添加小区',
        openCommunity: '开通小区',
        selectCommunity: '选填，请选择开通小区',
        functions: '功能',
        all: '全部'
      },
      edit: {
        title: '修改小区',
        openCommunity: '开通小区',
        functions: '功能',
        all: '全部'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定退出小区吗？',
        cancel: '点错了',
        confirmButton: '确认退出'
      },
      fetchError: '获取小区数据失败'
    },
  }
}
